import React, { useRef, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { animateFadeLeft, animateStagger, animateParallax, animateImageReveal } from '../animations/animations'

function ChooseUs() {
    const sectionRef = useRef(null)
    const parallaxRef = useRef(null)

    useEffect(() => {
        const subtitle = sectionRef.current?.querySelector('.subtitle');
        const title = sectionRef.current?.querySelector('.title');
        const desc = sectionRef.current?.querySelector('p');
        const listItems = sectionRef.current?.querySelectorAll('li');
        const btn = sectionRef.current?.querySelector('.latest-Choose-us__content-btn');
        const images = sectionRef.current?.querySelectorAll('img.img-fluid');

        if (subtitle) animateFadeLeft(subtitle, 0.2);
        if (title) animateFadeLeft(title, 0.4);
        if (desc) animateFadeLeft(desc, 0.6);
        if (listItems) animateStagger(listItems, 0.8, 0.1);
        if (btn) animateFadeLeft(btn, 1);
        if (images) images.forEach((img, index) => animateImageReveal(img, 0.2 * index));

        if (parallaxRef.current) animateParallax(parallaxRef.current, 0.1);

    }, [])

    return (
        <section className="latest-Choose-us__area section-space overflow-hidden latest-Choose-bg" ref={sectionRef}>
            <div className="container p-relative z-index-1">
                <div className="latest-Choose-us__all-shape">
                    <div className="latest-Choose-us__bg-shape">
                        <img className="upDown-bottom img-fluid" src="assets/imgs/choose-us/bg-shape.svg" alt="Abstract Background Shape" />
                    </div>
                </div>
                <div className="latest-Choose-us__media-experience-box d-flex" ref={parallaxRef} data-speed="0.1">
                    <div className="title">
                        <h3><span className="count">25</span>+</h3>
                        <h4>Years</h4>
                    </div>
                    <div className="description">
                        <p>Of experience in printing service</p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-6 col-lg-6 col-md-7">
                        <div className="latest-Choose-us__content mb-40">
                            <h6 className="subtitle">Why Choose Us</h6>
                            <h2 className="title">Why People Choose Nexus ID Systems?</h2>
                            <p>At Nexus IDSystems, we are dedicated to setting ourselves apart from the competition. Our primary focus is on delivering the highest quality solutions at affordable prices. With a team of highly trained professionals, we prioritize providing our clients with an exceptional customer experience, constantly seeking ways to enhance our services and solutions.</p>

                            <div className="latest-Choose-us__content-text d-flex">
                                <div className="latest-Choose-us__content-text-box">
                                    <ul>
                                        <li><i className="fa-solid fa-circle-check"></i>Trusted Industry Leader</li>
                                        <li><i className="fa-solid fa-circle-check"></i>Customer-Centric Approach</li>
                                        <li><i className="fa-solid fa-circle-check"></i>Comprehensive Solutions</li>
                                        <li><i className="fa-solid fa-circle-check"></i>Innovation and Reliability</li>
                                        <li><i className="fa-solid fa-circle-check"></i>Personalised Approach</li>
                                        <li><i className="fa-solid fa-circle-check"></i>Value for Money</li>
                                    </ul>

                                </div>
                            </div>
                            <div className="latest-Choose-us__content-btn">
                                <Link to="/contact" className="rr-btn">Read More</Link>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-6 col-lg-6 col-md-5">
                        <div className="latest-Choose-us__media d-flex flex-row">
                            <div className="latest-Choose-us__media-img1">
                                <img className="img-fluid" src="assets/imgs/choose-us/chooes-us-img1.png" alt="Business Professionals discussing ID solutions" />
                            </div>
                            <div className="latest-Choose-us__media-img2">
                                <img src="assets/imgs/choose-us/chooes-us-img02.jpg" alt="High Quality ID Card Printing Service" className="img-fluid" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ChooseUs


